import React from "react";
import { useContext } from "react";
import { RecentLeaderContext } from "@/context/RecentLeaderBoardContext";
import GoalTimeStats from "@/components/GoalTimeStats";
import MatchDetail from "@/components/MatchDetail";
const GoalStatistic = ({ goalStats }) => {
  const { home, away } = useContext(RecentLeaderContext);

  return (
    <>
      {/*Thời gian ghi bàn*/}
      <GoalTimeStats home={home} away={away} goalStats={goalStats} />
      
      {/*Chi tiết về HT/FT*/}
      <MatchDetail home={home} away={away} goalStats={goalStats} />
    </>
  );
};

export default GoalStatistic;
